import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typography } from '@telus-uds/components-web';
import { Thead, Tr, Th, Td } from './css';
import getFormattedPricing from '../../utils';
import Row from './row';
import { powerFleetFieldType } from '../../../../utils/constant';

const Table = ({
  type,
  isRenewal,
  viewType,
  hardware,
  setHardware,
  list,
  total,
  setTotal,
  fieldType
}) => {

  const valueTotal = total[powerFleetFieldType[fieldType]];
  const getHeader = headerList => (
    <Thead>
      <Tr>
        {headerList.map(item => (
          <Th>{_.get(item, 'fields.title', '')}</Th>
        ))}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const grandTotal = Object.keys(hardware).reduce(
      (acc, current) => {
        const { unitPrice, additionalQuantity, isAccessory} = hardware[
          current
        ];

        if (isAccessory && unitPrice && additionalQuantity) {
            return {
              ...acc,
              [powerFleetFieldType[fieldType]]: acc[powerFleetFieldType[fieldType]] + unitPrice * +additionalQuantity
            };
          }
        return acc;
      },
      { [powerFleetFieldType[fieldType]]: 0 }
    );
    setTotal(previousValue => ({ ...previousValue, ...grandTotal }));
  }, [hardware]);

  return (
    <table>
      {list.map(hardwareItem =>
        _.get(hardwareItem, 'fields.isHeader', false) ? (
          getHeader(
            _.get(
              hardwareItem,
              `fields.${isRenewal ? 'headerListRenewal' : 'headerList'}`,
              []
            )
          )
        ) : (
          <Row
            key={_.get(hardwareItem, 'sys.id', '')}
            rowData={hardwareItem}
            isRenewal={isRenewal}
            viewType={viewType}
            hardware={hardware}
            setHardware={setHardware}
          />
        )
      )}
      <Tr style={{ background: '#f4f4f4' }}>
        <Td colSpan={isRenewal || type === 'ACCESSORY' ? 3 : 5}>
          <Typography variant={{ bold: true }}>Total</Typography>
        </Td>
        <Td>
          <Typography variant={{ bold: true }}>{getFormattedPricing(valueTotal)}</Typography>
        </Td>
      </Tr>
    </table>
  );
};

Table.propTypes = {
  type: PropTypes.string.isRequired,
  isRenewal: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  hardware: PropTypes.arrayOf(PropTypes.object).isRequired,
  setHardware: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.shape({
    ratePlan: PropTypes.number,
    subscriberList: PropTypes.number,
    additionalServices: PropTypes.number,
    addons: PropTypes.number,
    hardware: PropTypes.number,
    accessories: PropTypes.number
  }).isRequired,
  setTotal: PropTypes.func.isRequired,
  fieldType: PropTypes.string.isRequired
};

export default Table;
